import { http } from "./http";

export const taskSpeedsApi = {
  list: (taskUid) => http.get(`/tasks/${taskUid}/speeds`).then((r) => r.data),
  create: (taskUid, payload) => http.post(`/tasks/${taskUid}/speeds`, payload).then((r) => r.data),
  update: (taskUid, speedUid, payload) =>
    http.put(`/tasks/${taskUid}/speeds/${speedUid}`, payload).then((r) => r.data),
  remove: (taskUid, speedUid) => http.delete(`/tasks/${taskUid}/speeds/${speedUid}`).then((r) => r.data),
};
